import {connect} from '@modifi/redux'

import Footer, {FooterProps} from './Footer'
import {
  selectFooterNavigation,
  selectExtraLinks,
  selectFooterText,
  selectFooterSubText,
} from '../../../data/navigation'

const mapStateToProps = (
  state: Record<string, any>
): Pick<FooterProps, 'footerRoutes' | 'extraLinks' | 'footerText' | 'footerSubText'> => ({
  footerRoutes: selectFooterNavigation(state),
  extraLinks: selectExtraLinks(state),
  footerText: selectFooterText(state),
  footerSubText: selectFooterSubText(state),
})

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(Footer)
